import anime from 'animejs';
import Scene from '../classes/scene';
import SceneManager from '../classes/scene-manager';
import { ScrollDirection } from '../classes/scroll-manager';
import { getEl } from '../helpers';

export default class NumberTicker extends Scene {

	constructor(manager: SceneManager, targetContainer: string) {
		super(manager, targetContainer);

		const hugeNumberEl = getEl('.huge-number');
		const containerEl = getEl('.ticker-container');

		//@ts-ignore
		containerEl.value = 0;

		this.addScrollAnimation({
			targets: containerEl,
			duration: 1500,
			delay: 0,
			value: [0, 100],
			left: ['85%', '50%'],
			easing: 'easeOutSine',
			update: anim => {

				const totalValue = 830000 / 1000;
				//@ts-ignore
				let t = (containerEl.value / 100);
				const sigfigs = Math.max(1, Math.floor((1 - t) * 10) * 10);
				let v = Math.round(t * totalValue / sigfigs) * sigfigs + '';

				//hugeNumberEl.innerHTML = (v.length > 3 ? v.substring(0, v.length-3) + ',' + v.substring(v.length-3) : v);
				hugeNumberEl.innerHTML = v + ',000';
			},
		}, this.elContainer.querySelector('.ticker-base'), 500, 0, 0.6, 0.3, 0);
		
		this.addScrollAnimation({
			targets: getEl('.img-reda'),
			duration: 1500,
			delay: 0,
			translateX: ['-10%', '0%'],
			easing: 'easeOutCubic',
		}, getEl('.reda-scroller'), 300, 0, 1, 0.2, 0.6);
		
		
	}

}
